import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { statConstants, statModels } from '..';

export const useStatCallHistoryCustomField = (
  props: {
    fieldId?: number | null;
    callType?: string | null;
    startDate?: number;
    finishDate?: number;
    employeeId?: number[] | null | undefined;
    pipeId?: number | null;
    statuses?: string[];
    durationStart?: number | null;
    durationFinish?: number | null;
    talkTimeStart?: number | null;
    talkTimeFinish?: number | null;
  } = {}
) =>
  useQuery<statModels.ICallHistoryCustomField>({
    queryKey: [statConstants.queryKeys.STAT_CALL_HISTORY_CUSTOM_FIELD, props],
    queryFn: async () => {
      const res = await $api.post('/v1/stat/call-history/custom-field', { ...props });

      return res?.data?.data;
    },
    enabled: !!props?.fieldId
  });
